// export const  BASE_URL = "http://localhost/WC/static/API"  //local
export const  BASE_URL = "https://maiecochem.com/static/API"